'use strict';

/**
 * Module definition for the create/edit object module
 *
 * @category   Module
 * @module     edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Marionette = require('backbone-marionette');
var Controller = require('./controller');

var EditModule = Marionette.Module.extend({
    startWithParent: true,

    onStart: function(options) {
        var app = this.app;

        var controller = this.controller = new Controller({
            app: app,
            module: this,
        });

        app.addInitializer(function(){
            app.router.processAppRoutes(controller, controller.routes);
        }.bind(this));
    },
});

module.exports = EditModule;